import topsGeneral from '@/store/modules/tops/general';

export default {
  topsGeneral,
};
